import { render, staticRenderFns } from "./clear_cache.vue?vue&type=template&id=b41c3e08&"
import script from "./clear_cache.vue?vue&type=script&lang=js&"
export * from "./clear_cache.vue?vue&type=script&lang=js&"
import style0 from "./clear_cache.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports